export default __webpack_public_path__ + "static/media/Peru.fa533f34.png";